import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import GlassContainer from '../components/ui/GlassContainer'

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-primary-900 noise-bg">
      <Header />
      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <GlassContainer variant="prominent" className="p-8">
            <div className="mb-8">
              <Link to="/" className="text-accent-blue hover:text-accent-blue/80 transition-colors mb-4 inline-block">
                &larr; Back to Home
              </Link>
              <h1 className="heading-xl mb-4">Terms of Service</h1>
              <p className="body-lg text-text-muted">Last updated: March 2026</p>
            </div>

            <div className="prose prose-invert max-w-none">
              <section className="mb-8">
                <h2 className="heading-lg mb-4">Agreement</h2>
                <p className="body-lg mb-4">
                  By using CongressMCP software, you agree to these terms.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="heading-lg mb-4">License</h2>
                <p className="body-lg mb-4">
                  CongressMCP is released under the Sustainable Use License. You may use, copy, modify, and
                  distribute the software, including for commercial purposes. You may not provide the Software
                  to third parties as a hosted or managed service that replicates the core functionality. See
                  the full license at{' '}
                  <a href="https://github.com/amurshak/congressMCP/blob/master/LICENSE" target="_blank" rel="noopener noreferrer" className="text-accent-blue hover:text-accent-blue/80">
                    GitHub
                  </a>{' '}
                  for details.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="heading-lg mb-4">Data Sources</h2>
                <p className="body-lg mb-4">
                  Congressional data is sourced from the Congress.gov API, an official U.S. government service.
                  Data accuracy and availability depend on the upstream API. We make no guarantees about the
                  completeness, accuracy, or timeliness of the data returned.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="heading-lg mb-4">Congress.gov API</h2>
                <p className="body-lg mb-4">
                  Your use of the Congress.gov API is subject to their terms of service. You are responsible
                  for obtaining your own API key and complying with their usage policies.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="heading-lg mb-4">No Warranty</h2>
                <p className="body-lg mb-4">
                  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
                  INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                  PURPOSE AND NONINFRINGEMENT.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="heading-lg mb-4">Limitation of Liability</h2>
                <p className="body-lg mb-4">
                  IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
                  OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
                  OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="heading-lg mb-4">Contact</h2>
                <p className="body-lg">
                  Questions? Open an issue on{' '}
                  <a href="https://github.com/amurshak/congressMCP/issues" target="_blank" rel="noopener noreferrer" className="text-accent-blue hover:text-accent-blue/80">
                    GitHub
                  </a>.
                </p>
              </section>
            </div>
          </GlassContainer>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default TermsOfService
